"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridColumnElement = exports.getDefinedSize = exports.getWidth = exports.getPadding = exports.getMarginInlineStart = exports.getMarginInlineEnd = exports.getWithoutZeroDecimal = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const Theme_1 = require("../Theme");
const getWithoutZeroDecimal = (num) => {
    return num.toFixed(6).replace(/0*$/, "").replace(/\.$/, "");
};
exports.getWithoutZeroDecimal = getWithoutZeroDecimal;
const getMarginInlineEnd = (maxWidth, gutterWidth, marginWidth, fillGapEnd = false, fill) => {
    const extraGutterWidth = fillGapEnd ? -(gutterWidth / 2) : gutterWidth / 2;
    return fill
        ? `calc(min(-50vw + ${maxWidth / 2}px, ${-(marginWidth - gutterWidth)}px) + ${extraGutterWidth - gutterWidth}px)`
        : `${extraGutterWidth}px`;
};
exports.getMarginInlineEnd = getMarginInlineEnd;
const getMarginInlineStart = (maxWidth, columnCount, gutterWidth, marginWidth, push, fillGapStart = false, fill) => {
    const baseGutterWidth = gutterWidth / 2;
    const extraGutterWidth = fillGapStart ? gutterWidth : 0;
    const pushWidth = push
        ? `${(0, exports.getWithoutZeroDecimal)((push / columnCount) * 100)}% + `
        : "";
    if (fill) {
        return `calc(${pushWidth}min(-50vw + ${maxWidth / 2 + gutterWidth}px, -${marginWidth - gutterWidth}px) + ${-baseGutterWidth}px)`;
    }
    return !push
        ? `${baseGutterWidth - extraGutterWidth}px`
        : `calc(${pushWidth}${baseGutterWidth - extraGutterWidth}px)`;
};
exports.getMarginInlineStart = getMarginInlineStart;
const getPadding = (maxWidth, gutterWidth, marginWidth, fillGap = false, fill) => {
    return fill
        ? `calc(max(50vw - ${maxWidth / 2 + gutterWidth}px, ${marginWidth - gutterWidth}px) + ${gutterWidth - (fillGap ? gutterWidth : 0)}px)`
        : "0";
};
exports.getPadding = getPadding;
const getWidth = (columnCount, gutterWidth, size, fillGapStart = false, fillGapEnd = false) => {
    const extraGutterWidth = -gutterWidth +
        (fillGapStart ? gutterWidth : 0) +
        (fillGapEnd ? gutterWidth : 0);
    return `calc(${(0, exports.getWithoutZeroDecimal)(Math.min(size / columnCount, 1) * 100)}%${extraGutterWidth === 0 ? "" : ` + ${extraGutterWidth}px`})`;
};
exports.getWidth = getWidth;
const getDefinedSize = (sizes, startSize, maxSize) => {
    for (let i = startSize; i < sizes.length; i++) {
        const sizeCurrent = sizes[i];
        if (sizeCurrent !== null) {
            return sizeCurrent;
        }
    }
    return maxSize;
};
exports.getDefinedSize = getDefinedSize;
exports.GridColumnElement = react_1.default.forwardRef((_a, ref) => {
    var { fillEnd, fillGapEnd, fillGapStart, fillStart, parentSize, push, size, sx } = _a, props = __rest(_a, ["fillEnd", "fillGapEnd", "fillGapStart", "fillStart", "parentSize", "push", "size", "sx"]);
    const theme = (0, Theme_1.useThemeWithoutTypes)();
    const styles = react_1.default.useMemo(() => ({
        boxSizing: "initial",
        flexShrink: 0,
        marginInlineEnd: [
            (0, exports.getMarginInlineEnd)(theme.sizes.containerMobileMaxWidth, theme.sizes.gridMobileColumnGutter, theme.sizes.containerMobileMargin, fillGapEnd, fillEnd),
            (0, exports.getMarginInlineEnd)(theme.sizes.containerTabletMaxWidth, theme.sizes.gridTabletColumnGutter, theme.sizes.containerTabletMargin, fillGapEnd, fillEnd),
            (0, exports.getMarginInlineEnd)(theme.sizes.containerDesktopMaxWidth, theme.sizes.gridDesktopColumnGutter, theme.sizes.containerDesktopMargin, fillGapEnd, fillEnd)
        ],
        marginInlineStart: [
            (0, exports.getMarginInlineStart)(theme.sizes.containerMobileMaxWidth, parentSize[0] || theme.grid.gridMobileColumnCount, theme.sizes.gridMobileColumnGutter, theme.sizes.containerMobileMargin, (0, exports.getDefinedSize)(push, 0, 0), fillGapStart, fillStart),
            (0, exports.getMarginInlineStart)(theme.sizes.containerTabletMaxWidth, parentSize[1] || theme.grid.gridTabletColumnCount, theme.sizes.gridTabletColumnGutter, theme.sizes.containerTabletMargin, (0, exports.getDefinedSize)(push, 1, 0), fillGapStart, fillStart),
            (0, exports.getMarginInlineStart)(theme.sizes.containerDesktopMaxWidth, parentSize[2] || theme.grid.gridDesktopColumnCount, theme.sizes.gridDesktopColumnGutter, theme.sizes.containerDesktopMargin, (0, exports.getDefinedSize)(push, 2, 0), fillGapStart, fillStart)
        ],
        paddingInlineEnd: [
            (0, exports.getPadding)(theme.sizes.containerMobileMaxWidth, theme.sizes.gridMobileColumnGutter, theme.sizes.containerMobileMargin, fillGapEnd, fillEnd),
            (0, exports.getPadding)(theme.sizes.containerTabletMaxWidth, theme.sizes.gridTabletColumnGutter, theme.sizes.containerTabletMargin, fillGapEnd, fillEnd),
            (0, exports.getPadding)(theme.sizes.containerDesktopMaxWidth, theme.sizes.gridDesktopColumnGutter, theme.sizes.containerDesktopMargin, fillGapEnd, fillEnd)
        ],
        paddingInlineStart: [
            (0, exports.getPadding)(theme.sizes.containerMobileMaxWidth, theme.sizes.gridMobileColumnGutter, theme.sizes.containerMobileMargin, fillGapStart, fillStart),
            (0, exports.getPadding)(theme.sizes.containerTabletMaxWidth, theme.sizes.gridTabletColumnGutter, theme.sizes.containerTabletMargin, fillGapStart, fillStart),
            (0, exports.getPadding)(theme.sizes.containerDesktopMaxWidth, theme.sizes.gridDesktopColumnGutter, theme.sizes.containerDesktopMargin, fillGapStart, fillStart)
        ],
        position: "relative",
        width: [
            (0, exports.getWidth)(parentSize[0] || theme.grid.gridMobileColumnCount, theme.sizes.gridMobileColumnGutter, (0, exports.getDefinedSize)(size, 0, theme.grid.gridMobileColumnCount), fillGapStart, fillGapEnd),
            (0, exports.getWidth)(parentSize[1] || theme.grid.gridTabletColumnCount, theme.sizes.gridTabletColumnGutter, (0, exports.getDefinedSize)(size, 1, theme.grid.gridTabletColumnCount), fillGapStart, fillGapEnd),
            (0, exports.getWidth)(parentSize[2] || theme.grid.gridDesktopColumnCount, theme.sizes.gridDesktopColumnGutter, (0, exports.getDefinedSize)(size, 2, theme.grid.gridDesktopColumnCount), fillGapStart, fillGapEnd)
        ]
    }), [
        fillEnd,
        fillGapEnd,
        fillGapStart,
        fillStart,
        parentSize,
        push,
        size,
        theme
    ]);
    return (react_1.default.createElement(__1.Box, Object.assign({ ref: ref, sx: Object.assign(Object.assign({ display: "flex", flexDirection: "column" }, sx), styles
        // This element requires calculated sizing values and can't use
        // the Box sx props from the theme.
        ) }, props)));
});
exports.GridColumnElement.displayName = "GridColumnElement";
//# sourceMappingURL=GridColumnElement.js.map